const parseMarkdownLinkToHtml = (markdownText: string) => {
  const pattern = /\[(.*?)]\((.*?)\)/g;
  const replaceCallback = (_: string, text: string, url: string) => {
    if (text.startsWith("*")) {
      const textWithoutAsterisk = text.replace("*", "");
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${textWithoutAsterisk}</a>`;
    }

    return `<a href="${url}" >${text}</a>`;
  };

  const htmlText = markdownText.replaceAll(pattern, replaceCallback);
  return htmlText;
};

export default parseMarkdownLinkToHtml;
